import { useContext } from 'react';
import { Button } from '@givebutter/primitives/button';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContactTypeContext } from './ContactTypeContext';
import { ContactsViewContext } from 'assets/js/pages/contacts/ContactsViewContext';
import { LegacyBulkActionDropdownItems } from 'assets/js/pages/contacts/LegacyBulkActionDropdownItems';
import {
    ArchiveContactsDialog,
    DeleteContactsDialog,
    UpdateContactNotificationsDialog,
    UpdateTagsDialog,
} from 'assets/js/pages/contacts/bulk-actions';
import * as DropdownMenu from 'components/dropdown-menu';
import { TableContext } from 'components/table/TableContext';
import { useSelectedRowCount } from 'components/table/useSelectedRowCount';
import { ContactType } from 'constants/contacts';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useFlags } from 'launchdarkly-react-client-sdk';

const ContactsHeader = () => {
    const { contactBulkActions } = useFlags();
    const { accountId } = useCurrentAccount();
    const { table } = useContext(TableContext);
    const selectedRows = table.getSelectedRowModel().flatRows;
    const selectedRowCount = useSelectedRowCount();
    const isSelecting = table.getIsSomePageRowsSelected() || table.getIsAllPageRowsSelected();
    const { archivedInput } = useContext(ContactsViewContext);
    const isArchived = archivedInput === 'archived';
    const contactType = useContactTypeContext();
    const resource = contactType === ContactType.Individual ? 'contacts' : 'companies';

    if (!isSelecting) {
        return null;
    }

    return (
        <>
            <div className={'h-6 w-px bg-gray-300'} />
            <div className={'flex items-center gap-4'}>
                <p className={'text-base font-medium leading-none'}>{selectedRowCount} selected</p>
                <DropdownMenu.Root>
                    <DropdownMenu.Trigger asChild={true}>
                        <Button variant="outline" size="sm" color="neutral">
                            Actions
                            <FontAwesomeIcon icon={faChevronDown} />
                        </Button>
                    </DropdownMenu.Trigger>

                    <DropdownMenu.Content sideOffset={5} align={'start'}>
                        {contactBulkActions ? (
                            <>
                                <UpdateTagsDialog action="add" />
                                <UpdateTagsDialog action="remove" />
                                <UpdateContactNotificationsDialog />
                                <ArchiveContactsDialog isArchived={isArchived} />
                                <DeleteContactsDialog />
                            </>
                        ) : (
                            <LegacyBulkActionDropdownItems />
                        )}
                        <DropdownMenu.LinkItem
                            disabled={selectedRowCount > 1}
                            to={`/accounts/${accountId}/${resource}/convert/${selectedRows[0].id}`}
                        >
                            Convert to {resource === 'companies' ? 'individual' : 'company'}
                        </DropdownMenu.LinkItem>
                    </DropdownMenu.Content>
                </DropdownMenu.Root>
            </div>
        </>
    );
};

export { ContactsHeader };
